import React from "react";
import { useDropzone } from "react-dropzone";
import { Button, Container, Header, Icon, Image } from "semantic-ui-react";

function DropzoneCommon(props) {
  const {
    getRootProps,
    getInputProps,
    open,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    // Disable click and keydown behavior
    noClick: false,
    noKeyboard: true,
    onDrop: props.onDrop,
    accept: props.accept
  });

  return (
    <Container>
      <div {...getRootProps({ className: "ui dropzone" })} style={{ textAlign: "center", minHeight: '2rem' }}>
        <input {...getInputProps()} />
        {props.img ? <Image src={props.img} fluid style={{maxHeight: "200px", maxWidth: "200px"}} /> : ''}
        {props.video ? <video src={props.video} loop muted fluid style={{maxHeight: "200px", maxWidth: "200px"}}/> : ''}
        {props.text ? <p style={{display: "block", padding: "20px"}}>{props.text}</p> : ''}
      </div>
      <div style={{ textAlign: "center", minHeight: '2rem' }}>
        <Button
          size="mini"
          primary
          type="button"
          content="Upload"
          icon="upload"
          onClick={open}
        />
        {props.onTrash && (
          <Button
            size="mini"
            color="red"
            type="button"
            content="Remove"
            icon="trash"
            onClick={props.onTrash}
          />
        )}
      </div>
      {isDragAccept && (
        <div>
          <Header as="h5" icon textAlign="center" color="green">
            {props.img ? '' : <Icon name="cloud upload" />}
            Drop to upload
            <Header.Subheader>This file type is OK to upload</Header.Subheader>
          </Header>
        </div>
      )}
      {isDragReject && (
        <div>
          <Header as="h5" icon textAlign="center" color="red">
            {props.img ? '' : <Icon name="close" />}
            Invalid File
            <Header.Subheader>This file type is not supported</Header.Subheader>
          </Header>
        </div>
      )}
      {!isDragActive && (
        <div>
          <Header as="h5" icon textAlign="center">
            {props.img ? '' : <Icon name="upload" />}
            Drag 'n' drop
              <Header.Subheader>your file above or click the button</Header.Subheader>
          </Header>
        </div>
      )}
    </Container>
  );
}

export default DropzoneCommon;
